import { FC, Fragment, useState } from 'react';
import { SwipeableDrawer } from '@mui/material';
import { Box, BoxProps } from '../../box';
import { styled } from '../../../theme';
import { InfoSlots, InfoTranslateionSlots } from '../model';
import { InfoIcon } from '../../../icons';
import { SVGIconTokens } from '../../svgIcon';
import { PropsWithSlots } from '../../../types';
import { useIsMobile } from '../../../hooks';
import { InfoModal } from './InfoModal';
import { InfoTooltip } from './InfoTooltip';

type InfoProps = InfoTranslateionSlots & PropsWithSlots<InfoSlots>;

const Root = styled(Box, { name: 'InfoRoot' })(({ theme }) => ({
  [SVGIconTokens.Size]: theme.spacing(3),
  [SVGIconTokens.Fill]: theme.palette['brand gray'],
}));

const defaultSlots: InfoSlots = {
  icon: <InfoIcon />,
  tooltip: InfoTooltip,
  modalInner: InfoModal,
};

export const Info: FC<InfoProps> = ({ slots, translations }) => {
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);
  const { icon, modalInner: ModalInner, tooltip } = (slots ?? defaultSlots) as Required<InfoSlots>;

  const Tooltip = !isMobile ? tooltip : Fragment;

  const handleClose = () => {
    setIsOpen(false);
  };

  const rootProps: BoxProps = isMobile
    ? {
        onClick: () => setIsOpen(true),
      }
    : {};

  return (
    <Tooltip translations={translations}>
      <Root {...rootProps}>{icon}</Root>
      {isMobile && (
        <SwipeableDrawer
          SlideProps={{ onExit: handleClose }}
          anchor="bottom"
          onClose={handleClose}
          onOpen={console.debug}
          open={isOpen}
          sx={{ zIndex: 1999 }}
          transitionDuration={300}
          variant="temporary"
        >
          <ModalInner onClose={handleClose} translations={translations} />
        </SwipeableDrawer>
      )}
    </Tooltip>
  );
};
